import React, { useState, useContext } from "react";
import "./RecentAgents.scss";
import { ReactComponent as DownArrow } from "../../assets/images/ralvie/dropDown.svg";
import { ReactComponent as ArrowUp } from "../../assets/images/ralvie/ArrowUp.svg";
import { ReactComponent as Profileicon } from "../../assets/images/nav-icons/profile-icon_active.svg";
import { ReactComponent as Emailicon } from "../../assets/images/email-icon.svg";
import { ReactComponent as Summaryicon } from "../../assets/images/summary-icon.svg";
import AppContext from "../../config/AppContext";

const CollapsibleSection = ({ title, children, defaultCollapsed = false }) => {
    const [collapsed, setCollapsed] = useState(defaultCollapsed);
    const { mode } = useContext(AppContext);

    return (
        <div className="collapsible-section">
            <div className="header-compoents" onClick={() => setCollapsed(!collapsed)}>
                <span className={mode === "dark" ? "sectionTitle-title-dark" : "sectionTitle-title"}>{title}</span>
                <span className="arrow-toggle">{collapsed ? <DownArrow /> : <ArrowUp />}</span>
            </div>
            <div className="content-wrapper" style={{
                maxHeight: collapsed ? "0px" : "none",
                overflow: "hidden",
                transition: "max-height 0.3s ease-in-out"
            }}>
                {children}
            </div>
        </div>
    );
};

const RecentAgents = ({ agents = [], selectedAgentId, onSelectAgent }) => {
    const { mode } = useContext(AppContext);
    const [showAllConversations, setShowAllConversations] = useState(false);
    const recentConversations = [
        { id: 1, title: "Email draft about project " },
        { id: 2, title: "Summary of weekly meetings" },
        { id: 3, title: "Priority email sorting" },
        { id: 4, title: "Follow-up message template" },
        { id: 5, title: "Email draft about project " },
        { id: 6, title: "Summary of weekly meetings" },
        { id: 7, title: "Priority email sorting" },
        { id: 8, title: "Follow-up message template" },
        { id: 9, title: "Email draft about project " },
        { id: 10, title: "Summary of weekly meetings" },
        { id: 11, title: "Priority email sorting" },
        { id: 12, title: "Follow-up message template" },
        { id: 13, title: "Follow-up message template" },
        { id: 14, title: "Email draft about project " },
        { id: 15, title: "Summary of weekly meetings" },
        { id: 16, title: "Priority email sorting" },
        { id: 17, title: "Follow-up message template" },
        { id: 18, title: "Email draft about project " },
        { id: 19, title: "Summary of weekly meetings" },
        { id: 20, title: "Priority email sorting" },
        { id: 21, title: "Follow-up message template" },
    ];

    const toggleConversations = () => {
        setShowAllConversations(!showAllConversations);
    };

    return (
        <div className={mode === "dark" ? "ask-summary-card-dark" : "ask-summary-card"}>
            <div className="section-wrapper">
                <CollapsibleSection title="Agents">
                    <div className="agent-list">
                        {agents.map((agent) => (
                            <div
                                key={agent.id}
                                className={`${mode === "dark" ? "agent-item-dark" : "agent-item"} ${agent.id === selectedAgentId ? "selected" : ""}`}
                                onClick={() => onSelectAgent(agent.id)}
                            >
                                {agent.id === "email" ? (
                                    <Emailicon className="agent-icon" />
                                ) : (
                                    <Summaryicon className="agent-icon" />
                                )}
                                <span className={mode === "dark" ? "agent-name-title-dark" : "agent-name-title"}>{agent.name}</span>
                            </div>
                        ))}
                    </div>
                </CollapsibleSection>

                <div className="section-spacer" />

                <CollapsibleSection title="Recent Conversations" defaultCollapsed={false}>
                    <>
                        <div
                            className="recent-conversations-container"
                            style={{
                                maxHeight: showAllConversations ? '330px' : '100px',
                                overflowY: 'auto'
                            }}
                        >
                            {recentConversations.map((conversation) => (
                                <div key={conversation.id} className="conversation-item">
                                    <span className={mode === "dark" ? "conversation-title-dark" : "conversation-title"}>{conversation.title}</span>
                                </div>
                            ))}
                        </div>
                        <button
                            className={`${mode === "dark" ? "toggle-conversations-dark" : "toggle-conversations"}`}
                            onClick={toggleConversations}
                        >
                            {showAllConversations ? 'see less' : 'see more'}
                        </button>
                    </>
                </CollapsibleSection>
            </div>
        </div>
    );
};

export default RecentAgents;